[
  {
    "id": 0,
    "name": "Background",
    "color": "#FFFFFF"
  },
  {
    "id": 1,
    "name": "17db",
    "color": "#13cf8e"
  },
  {
    "id": 2,
    "name": "17mb",
    "color": "#d00367"
  },
  {
    "id": 3,
    "name": "17dp",
    "color": "#f40eea"
  },
  {
    "id": 4,
    "name": "17mp",
    "color": "#134bf6"
  },
  {
    "id": 5,
    "name": "16db",
    "color": "#13cf8e"
  },
  {
    "id": 6,
    "name": "16mb",
    "color": "#d00367"
  },
  {
    "id": 7,
    "name": "16dp",
    "color": "#f40eea"
  },
  {
    "id": 8,
    "name": "16mp",
    "color": "#134bf6"
  },
  {
    "id": 9,
    "name": "15b",
    "color": "#0def0c"
  },
  {
    "id": 10,
    "name": "15p",
    "color": "#d75303"
  },
  {
    "id": 11,
    "name": "14b",
    "color": "#0def0c"
  },
  {
    "id": 12,
    "name": "14p",
    "color": "#d75303"
  },
  {
    "id": 13,
    "name": "13C",
    "color": "#c527e7"
  },
  {
    "id": 14,
    "name": "23C",
    "color": "#c527e7"
  },
  {
    "id": 15,
    "name": "24b",
    "color": "#0def0c"
  },
  {
    "id": 16,
    "name": "24p",
    "color": "#d75303"
  },
  {
    "id": 17,
    "name": "25b",
    "color": "#0def0c"
  },
  {
    "id": 18,
    "name": "25p",
    "color": "#d75303"
  },
  {
    "id": 19,
    "name": "26mb",
    "color": "#d00367"
  },
  {
    "id": 20,
    "name": "26mp",
    "color": "#134bf6"
  },
  {
    "id": 21,
    "name": "26db",
    "color": "#13cf8e"
  },
  {
    "id": 22,
    "name": "26dp",
    "color": "#f40eea"
  },
  {
    "id": 23,
    "name": "27mb",
    "color": "#d00367"
  },
  {
    "id": 24,
    "name": "27mp",
    "color": "#134bf6"
  },
  {
    "id": 25,
    "name": "27db",
    "color": "#13cf8e"
  },
  {
    "id": 26,
    "name": "27dp",
    "color": "#f40eea"
  },
  {
    "id": 27,
    "name": "37db",
    "color": "#13cf8e"
  },
  {
    "id": 28,
    "name": "37dl",
    "color": "#f88800"
  },
  {
    "id": 29,
    "name": "37ml",
    "color": "#db1618"
  },
  {
    "id": 30,
    "name": "37mb",
    "color": "#d00367"
  },
  {
    "id": 31,
    "name": "36db",
    "color": "#13cf8e"
  },
  {
    "id": 32,
    "name": "36dl",
    "color": "#f88800"
  },
  {
    "id": 33,
    "name": "36ml",
    "color": "#db1618"
  },
  {
    "id": 34,
    "name": "36mb",
    "color": "#d00367"
  },
  {
    "id": 35,
    "name": "35l",
    "color": "#54dc26"
  },
  {
    "id": 36,
    "name": "35b",
    "color": "#0def0c"
  },
  {
    "id": 37,
    "name": "34b",
    "color": "#0def0c"
  },
  {
    "id": 38,
    "name": "34l",
    "color": "#54dc26"
  },
  {
    "id": 39,
    "name": "33C",
    "color": "#c527e7"
  },
  {
    "id": 40,
    "name": "43C",
    "color": "#c527e7"
  },
  {
    "id": 41,
    "name": "44b",
    "color": "#0def0c"
  },
  {
    "id": 42,
    "name": "44l",
    "color": "#54dc26"
  },
  {
    "id": 43,
    "name": "45b",
    "color": "#0def0c"
  },
  {
    "id": 44,
    "name": "45l",
    "color": "#54dc26"
  },
  {
    "id": 45,
    "name": "46db",
    "color": "#13cf8e"
  },
  {
    "id": 46,
    "name": "46mb",
    "color": "#d00367"
  },
  {
    "id": 47,
    "name": "46dl",
    "color": "#f88800"
  },
  {
    "id": 48,
    "name": "46ml",
    "color": "#db1618"
  },
  {
    "id": 49,
    "name": "47db",
    "color": "#13cf8e"
  },
  {
    "id": 50,
    "name": "47mb",
    "color": "#d00367"
  },
  {
    "id": 51,
    "name": "47dl",
    "color": "#f88800"
  },
  {
    "id": 52,
    "name": "47ml",
    "color": "#db1618"
  },
  {
    "id": 53,
    "name": "12I",
    "color": "#f42786"
  },
  {
    "id": 54,
    "name": "11I",
    "color": "#f42786"
  },
  {
    "id": 55,
    "name": "21I",
    "color": "#f42786"
  },
  {
    "id": 56,
    "name": "22I",
    "color": "#f42786"
  },
  {
    "id": 57,
    "name": "41I",
    "color": "#f42786"
  },
  {
    "id": 58,
    "name": "42I",
    "color": "#f42786"
  },
  {
    "id": 59,
    "name": "31I",
    "color": "#f42786"
  },
  {
    "id": 60,
    "name": "32I",
    "color": "#f42786"
  },
  {
    "id": 61,
    "name": "17MMR",
    "color": "#1d9dd0"
  },
  {
    "id": 62,
    "name": "16MMR",
    "color": "#1d9dd0"
  },
  {
    "id": 63,
    "name": "15MMR",
    "color": "#1d9dd0"
  },
  {
    "id": 64,
    "name": "14MMR",
    "color": "#1d9dd0"
  },
  {
    "id": 65,
    "name": "24MMR",
    "color": "#1d9dd0"
  },
  {
    "id": 66,
    "name": "25MMR",
    "color": "#1d9dd0"
  },
  {
    "id": 67,
    "name": "26MMR",
    "color": "#1d9dd0"
  },
  {
    "id": 68,
    "name": "27MMR",
    "color": "#1d9dd0"
  },
  {
    "id": 69,
    "name": "27DMR",
    "color": "#b01dd8"
  },
  {
    "id": 70,
    "name": "26DMR",
    "color": "#b01dd8"
  },
  {
    "id": 71,
    "name": "25DMR",
    "color": "#b01dd8"
  },
  {
    "id": 72,
    "name": "24DMR",
    "color": "#b01dd8"
  },
  {
    "id": 73,
    "name": "37MMR",
    "color": "#1d9dd0"
  },
  {
    "id": 74,
    "name": "36MMR",
    "color": "#1d9dd0"
  },
  {
    "id": 75,
    "name": "35MMR",
    "color": "#1d9dd0"
  },
  {
    "id": 76,
    "name": "34MMR",
    "color": "#1d9dd0"
  },
  {
    "id": 77,
    "name": "44MMR",
    "color": "#1d9dd0"
  },
  {
    "id": 78,
    "name": "45MMR",
    "color": "#1d9dd0"
  },
  {
    "id": 79,
    "name": "46MMR",
    "color": "#1d9dd0"
  },
  {
    "id": 80,
    "name": "47MMR",
    "color": "#1d9dd0"
  },
  {
    "id": 81,
    "name": "47DMR",
    "color": "#b01dd8"
  },
  {
    "id": 82,
    "name": "46DMR",
    "color": "#b01dd8"
  },
  {
    "id": 83,
    "name": "45DMR",
    "color": "#b01dd8"
  },
  {
    "id": 84,
    "name": "44DMR",
    "color": "#b01dd8"
  },
  {
    "id": 85,
    "name": "34DMR",
    "color": "#b01dd8"
  },
  {
    "id": 86,
    "name": "35DMR",
    "color": "#b01dd8"
  },
  {
    "id": 87,
    "name": "36DMR",
    "color": "#b01dd8"
  },
  {
    "id": 88,
    "name": "37DMR",
    "color": "#b01dd8"
  },
  {
    "id": 89,
    "name": "17DMR",
    "color": "#b01dd8"
  },
  {
    "id": 90,
    "name": "16DMR",
    "color": "#b01dd8"
  },
  {
    "id": 91,
    "name": "15DMR",
    "color": "#b01dd8"
  },
  {
    "id": 92,
    "name": "14DMR",
    "color": "#b01dd8"
  }
]
